import { render, staticRenderFns } from "./pj.vue?vue&type=template&id=c233f87e&scoped=true&"
import script from "./pj.vue?vue&type=script&lang=js&"
export * from "./pj.vue?vue&type=script&lang=js&"
import style0 from "./pj.vue?vue&type=style&index=0&id=c233f87e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c233f87e",
  null
  
)

export default component.exports